import React from 'react';
import { useDarkMode } from '../../DarkModeContext';
import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import SidebarCard from "components/sidebar/componentsrtl/SidebarCard";
import routes from "routes.js";

const Sidebar = ({ open, onClose }) => {
  const { isDarkMode } = useDarkMode();

  const groupedRoutes = {
    main: routes.filter(route => !['Teams', 'Coaches', 'Players', 'Player Analytics','Team Analytics'].includes(route.name) && !route.hidden),
    team: routes.filter(route => ['Teams', 'Coaches', 'Players'].includes(route.name) && !route.hidden),
    analytics: routes.filter(route => ['Player Analytics', 'Team Analytics'].includes(route.name) && !route.hidden)
  };
  
  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 flex min-h-full flex-col bg-white pb-10 shadow-2xl shadow-white/5 transition-all dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? "translate-x-0" : "-translate-x-96"
      } ${isDarkMode ? 'dark' : ''}`}
    >
      <span
        className="absolute top-4 right-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </span>

      <div className={`mx-[56px] mt-[50px] flex items-center`}>
        <div className="mt-1 ml-1 h-2.5">
          <img
            src={isDarkMode 
              ? require('../../assets/img/dashboards/logoDark.png')
              : require('../../assets/img/dashboards/logoLight.png')}
            alt="Sports Impact Technologies Logo"
            className="h-16 w-auto"
          />
        </div>
      </div>
      <div className="mt-[58px] mb-7 h-px bg-gray-300 dark:bg-white/30" />
      
      <ul className="mb-auto pt-1">
        <Links routes={groupedRoutes.main} />
        
        <li className="mt-8 mb-2 ml-8 font-semibold text-gray-500 dark:text-gray-400">
          Team Management
        </li>
        <div className="mb-2 ml-8 h-px bg-gray-300 dark:bg-white/30" />
        <Links routes={groupedRoutes.team} />
        
        <li className="mt-8 mb-2 ml-8 font-semibold text-gray-500 dark:text-gray-400">
          Analytics
        </li>
        <div className="mb-2 ml-8 h-px bg-gray-300 dark:bg-white/30" />
        <Links routes={groupedRoutes.analytics} />
      </ul>

      <div className="flex justify-center">
        <SidebarCard />
      </div>
    </div>
  );
};

export default Sidebar;